import { AlertTriangle } from 'lucide-react'
import { extractApiError } from '../lib/api'

/**
 * [QA-14] Non-blocking notice for a failed BACKGROUND refetch.
 *
 * React Query keeps the last good `data` when a refetch fails and only flips
 * `isError`. The dashboards used to check `isError` first, so one failed 60 s
 * poll (plus its retry) replaced the whole body with a single error line until
 * a later poll succeeded. The rule now — the one StorageDonut / AiUsageMeter
 * already follow — is: cached data keeps rendering, and this line says it
 * could not be refreshed. A blocking error is shown only when there is no
 * data at all.
 */
export default function RefreshFailedNotice({ error, onRetry }) {
  return (
    <div
      role="status"
      className="mb-4 flex items-start gap-2 rounded-lg border border-[color:var(--color-warning-border)] bg-[color:var(--color-warning-bg)] px-3 py-2 text-[13px] text-[color:var(--color-ink)]"
    >
      <AlertTriangle size={14} className="mt-0.5 shrink-0 text-[color:var(--color-warning)]" />
      <span className="flex-1">
        Couldn&apos;t refresh — showing the last loaded numbers.{' '}
        <span className="text-[color:var(--color-ink-muted)]">
          {extractApiError(error).message}
        </span>
      </span>
      {onRetry ? (
        <button
          type="button"
          onClick={onRetry}
          className="shrink-0 font-medium text-[color:var(--color-accent-strong)] hover:underline focus-visible:underline"
        >
          Retry
        </button>
      ) : null}
    </div>
  )
}
